export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=0f8456cd&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/materials/index.vue?vue&type=template&id=0f8456cd&
// module id = 1479
// module chunks = 0